import React from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";

export default function Reception() {
  return (
    <section className="contacts education">
      <Breadcrumbs />
      <h1 className="contacts__title history__title licenses__title">
        График работы врачей консультативно-диагностического отделения на 2026
        год
      </h1>

      <table className="contacts__table first_table">
        <tbody>
          {/* <tr className="contacts__line"> */}
          <th className="contacts__caption" colSpan={7}>
            Мужская венерология
          </th>
          {/* </tr> */}
          <tr className="contacts__line">
            <td className="contacts__cell second_cell">Врач</td>
            {/* <td className="contacts__cell second_cell">Кабинет</td> */}
            <td className="contacts__cell second_cell">Понедельник</td>
            <td className="contacts__cell second_cell">Вторник</td>
            <td className="contacts__cell second_cell">Среда</td>
            <td className="contacts__cell second_cell">Четверг</td>
            <td className="contacts__cell second_cell">Пятница</td>
          </tr>
          {/* <tr className="contacts__line">
            <td className="contacts__cell second_cell">
              Большагин Сергей Александрович
            </td>
            {/* <td className="contacts__cell second_cell">11</td>
            <td className="contacts__cell second_cell"></td>
            <td className="contacts__cell second_cell"></td>
            <td className="contacts__cell second_cell">14:00 - 18:00</td>
            <td className="contacts__cell second_cell">14:00 - 18:00</td>
            <td className="contacts__cell second_cell"></td>
          </tr> */}
          <tr className="contacts__line">
            <td className="contacts__cell second_cell">
              Орехов Дмитрий Витальевич <br></br>Высшая категория
            </td>
            {/* <td className="contacts__cell second_cell">12</td> */}
            <td className="contacts__cell second_cell">09:00 - 16:00</td>
            <td className="contacts__cell second_cell">09:00 - 18:00</td>
            <td className="contacts__cell second_cell">09:00 - 16:00</td>
            <td className="contacts__cell second_cell">09:00 - 18:00</td>
            <td className="contacts__cell second_cell">09:00 - 18:00</td>
          </tr>
          <tr className="contacts__line">
            <td className="contacts__cell second_cell">
              Горбунов Андрей Петрович<br></br>К.М.Н.*
            </td>
            {/* <td className="contacts__cell second_cell">125</td> */}
            <td className="contacts__cell second_cell">09:00 - 14:00</td>
            <td className="contacts__cell second_cell">11:00 - 14:00</td>
            <td className="contacts__cell second_cell">09:00 - 14:00</td>
            <td className="contacts__cell second_cell">11:00 - 14:00</td>
            <td className="contacts__cell second_cell">09:00 - 14:00</td>
          </tr>
          <tr className="contacts__line">
            <td className="contacts__cell second_cell">
              Скидан Николай Иванович<br></br>К.М.Н.
            </td>
            {/* <td className="contacts__cell second_cell">367</td> */}
            <td className="contacts__cell second_cell">16:00 - 18:00</td>
            <td className="contacts__cell second_cell">09:00 - 12:30</td>
            <td className="contacts__cell second_cell">16:00 - 18:00</td>
            <td className="contacts__cell second_cell">09:00 - 12:30</td>
            <td className="contacts__cell second_cell">16:00 - 18:00</td>
          </tr>
          <th className="contacts__caption" colSpan={7}>
            Женская венерология
          </th>
          <tr className="contacts__line">
            <td className="contacts__cell second_cell">Врач</td>
            {/* <td className="contacts__cell second_cell">Кабинет</td> */}
            <td className="contacts__cell second_cell">Понедельник</td>
            <td className="contacts__cell second_cell">Вторник</td>
            <td className="contacts__cell second_cell">Среда</td>
            <td className="contacts__cell second_cell">Четверг</td>
            <td className="contacts__cell second_cell">Пятница</td>
          </tr>
          <tr className="contacts__line">
            <td className="contacts__cell second_cell">
              Фарленкова Елена Юрьевна<br></br>Высшая категория
            </td>
            {/* <td className="contacts__cell second_cell">7</td> */}
            <td className="contacts__cell second_cell">09:00 - 15:00</td>
            <td className="contacts__cell second_cell">09:00 - 15:00</td>
            <td className="contacts__cell second_cell">13:00 - 16:00</td>
            <td className="contacts__cell second_cell">09:00 - 15:00</td>
            <td className="contacts__cell second_cell">09:00 - 15:00</td>
          </tr>

          <tr className="contacts__line">
            <td className="contacts__cell second_cell">
              Никитина Екатерина Владимировна<br></br>К.М.Н.
            </td>
            {/* <td className="contacts__cell second_cell">8</td> */}
            <td className="contacts__cell second_cell"></td>
            <td className="contacts__cell second_cell">09:00 - 17:00</td>
            <td className="contacts__cell second_cell">09:00 - 17:00</td>
            <td className="contacts__cell second_cell">09:00 - 17:00</td>
            <td className="contacts__cell second_cell"></td>
          </tr>

          <tr className="contacts__line">
            <td className="contacts__cell second_cell">
              Грекова Юлия Николаевна<br></br>Д.М.Н.*
            </td>
            {/* <td className="contacts__cell second_cell">305</td> */}
            <td className="contacts__cell second_cell">09:00 - 13:00</td>
            <td className="contacts__cell second_cell"></td>
            <td className="contacts__cell second_cell">09:00 - 13:00</td>
            <td className="contacts__cell second_cell"></td>
            <td className="contacts__cell second_cell">09:00 - 13:00</td>
          </tr>

          <th className="contacts__caption" colSpan={7}>
            Прием Гинеколога
          </th>
          <tr className="contacts__line">
            <td className="contacts__cell second_cell">Врач</td>
            {/* <td className="contacts__cell second_cell">Кабинет</td> */}
            <td className="contacts__cell second_cell">Понедельник</td>
            <td className="contacts__cell second_cell">Вторник</td>
            <td className="contacts__cell second_cell">Среда</td>
            <td className="contacts__cell second_cell">Четверг</td>
            <td className="contacts__cell second_cell">Пятница</td>
          </tr>
          <tr className="contacts__line">
            <td className="contacts__cell second_cell">
              Елькина Маргарита Викторовна
            </td>
            {/* <td className="contacts__cell second_cell">13</td> */}
            <td className="contacts__cell second_cell"></td>
            <td className="contacts__cell second_cell">09:00 - 13:00</td>
            <td className="contacts__cell second_cell"></td>
            <td className="contacts__cell second_cell">09:00 - 13:00</td>
            <td className="contacts__cell second_cell"></td>
          </tr>

          <th className="contacts__caption" colSpan={7}>
            Прием Терапевта
          </th>
          <tr className="contacts__line">
            <td className="contacts__cell second_cell">Врач</td>
            {/* <td className="contacts__cell second_cell">Кабинет</td> */}
            <td className="contacts__cell second_cell">Понедельник</td>
            <td className="contacts__cell second_cell">Вторник</td>
            <td className="contacts__cell second_cell">Среда</td>
            <td className="contacts__cell second_cell">Четверг</td>
            <td className="contacts__cell second_cell">Пятница</td>
          </tr>
          <tr className="contacts__line">
            <td className="contacts__cell second_cell">
              Филатова Елена Сергеевна
            </td>
            {/* <td className="contacts__cell second_cell">15</td> */}
            <td className="contacts__cell second_cell"></td>
            <td className="contacts__cell second_cell">13:00 - 15:00</td>
            <td className="contacts__cell second_cell">13:00 - 15:00</td>
            <td className="contacts__cell second_cell">13:00 - 15:00</td>
            <td className="contacts__cell second_cell"></td>
          </tr>

          <th className="contacts__caption" colSpan={7}>
            УЗИ-диагностика
          </th>
          <tr className="contacts__line">
            <td className="contacts__cell second_cell">Врач</td>
            {/* <td className="contacts__cell second_cell">Кабинет</td> */}
            <td className="contacts__cell second_cell">Понедельник</td>
            <td className="contacts__cell second_cell">Вторник</td>
            <td className="contacts__cell second_cell">Среда</td>
            <td className="contacts__cell second_cell">Четверг</td>
            <td className="contacts__cell second_cell">Пятница</td>
          </tr>
          <tr className="contacts__line">
            <td className="contacts__cell second_cell">
              Распутина Любовь Геннадьевна
            </td>
            {/* <td className="contacts__cell second_cell">15</td> */}
            <td className="contacts__cell second_cell">14:00 - 17:00</td>
            <td className="contacts__cell second_cell">15:00 - 17:00</td>
            <td className="contacts__cell second_cell">14:00 - 17:00</td>
            <td className="contacts__cell second_cell"></td>
            <td className="contacts__cell second_cell"></td>
          </tr>

          <th className="contacts__caption" colSpan={7}>
            Дерматология взрослая
          </th>
          <tr className="contacts__line">
            <td className="contacts__cell second_cell">Врач</td>
            {/* <td className="contacts__cell second_cell">Кабинет</td> */}
            <td className="contacts__cell second_cell">Понедельник</td>
            <td className="contacts__cell second_cell">Вторник</td>
            <td className="contacts__cell second_cell">Среда</td>
            <td className="contacts__cell second_cell">Четверг</td>
            <td className="contacts__cell second_cell">Пятница</td>
          </tr>

          <tr className="contacts__line">
            <td className="contacts__cell second_cell">
              Рабцевич Виталия Владимировна<br></br>Высшая категория
            </td>
            {/* <td className="contacts__cell second_cell">6</td> */}
            <td className="contacts__cell second_cell">09:00 - 16:00</td>
            <td className="contacts__cell second_cell">09:00 - 16:00</td>
            <td className="contacts__cell second_cell">09:00 - 16:00</td>
            <td className="contacts__cell second_cell">09:00 - 16:00</td>
            <td className="contacts__cell second_cell">09:00 - 16:00</td>
          </tr>

          <tr className="contacts__line">
            <td className="contacts__cell second_cell">
              Римар Ольга Генриховна<br></br>Высшая категория
            </td>
            {/* <td className="contacts__cell second_cell">8</td> */}
            <td className="contacts__cell second_cell">14:00 - 18:00</td>
            <td className="contacts__cell second_cell"></td>
            <td className="contacts__cell second_cell"></td>
            <td className="contacts__cell second_cell"></td>
            <td className="contacts__cell second_cell">14:00 - 18:00</td>
          </tr>
          {/* <tr className="contacts__line">
            <td className="contacts__cell second_cell">
              Никитина Екатерина Владимировна<br></br>К.М.Н.
            </td>
            <td className="contacts__cell second_cell">8</td>
            <td className="contacts__cell second_cell"></td>
            <td className="contacts__cell second_cell">09:00 - 16:30</td>
            <td className="contacts__cell second_cell">09:00 - 16:30</td>
            <td className="contacts__cell second_cell">09:00 - 16:30</td>
            <td className="contacts__cell second_cell"></td>
          </tr> */}
          <tr className="contacts__line">
            <td className="contacts__cell second_cell">
              Попов Кирилл Сергеевич<br></br>
            </td>
            {/* <td className="contacts__cell second_cell">9</td> */}
            <td className="contacts__cell second_cell">14:00 - 17:00</td>
            <td className="contacts__cell second_cell">14:00 - 17:00</td>
            <td className="contacts__cell second_cell"></td>
            <td className="contacts__cell second_cell">14:00 - 17:00</td>
            <td className="contacts__cell second_cell"></td>
          </tr>

          <tr className="contacts__line">
            <td className="contacts__cell second_cell">
              Полищук Антон Ильич<br></br>К.М.Н.
            </td>
            {/* <td className="contacts__cell second_cell">9</td> */}
            <td className="contacts__cell second_cell">09:00 - 13:00</td>
            <td className="contacts__cell second_cell"></td>
            <td className="contacts__cell second_cell">13:00 – 18:00</td>
            <td className="contacts__cell second_cell"></td>
            <td className="contacts__cell second_cell"></td>
          </tr>

          <tr className="contacts__line">
            <td className="contacts__cell second_cell">
              Каргина Кристина Вячеславовна<br></br>
            </td>
            {/* <td className="contacts__cell second_cell">301</td> */}
            <td className="contacts__cell second_cell"></td>
            <td className="contacts__cell second_cell">13:00 – 16:00</td>
            <td className="contacts__cell second_cell"></td>
            <td className="contacts__cell second_cell"></td>
            <td className="contacts__cell second_cell"></td>
          </tr>

          <tr className="contacts__line">
            <td className="contacts__cell second_cell">
              Кокорина Наталья Станиславовна<br></br>К.М.Н.
            </td>
            {/* <td className="contacts__cell second_cell">305</td> */}
            <td className="contacts__cell second_cell">09:30 – 17:00</td>
            <td className="contacts__cell second_cell">09:30 – 17:00</td>
            <td className="contacts__cell second_cell">13:00 – 17:00</td>
            <td className="contacts__cell second_cell">09:30 – 17:00</td>
            <td className="contacts__cell second_cell">09:30 – 14:00</td>
          </tr>

          <tr className="contacts__line">
            <td className="contacts__cell second_cell">
              Жулимова Наталья Леонидовна<br></br>К.М.Н.
            </td>
            {/* <td className="contacts__cell second_cell">302</td> */}
            <td className="contacts__cell second_cell">09:00 – 14:00</td>
            <td className="contacts__cell second_cell">09:00 – 14:00</td>
            <td className="contacts__cell second_cell">09:00 – 14:00</td>
            <td className="contacts__cell second_cell"></td>
            <td className="contacts__cell second_cell"></td>
          </tr>

          <tr className="contacts__line">
            <td className="contacts__cell second_cell">
              Дертко Максим Евгеньевич<br></br>
            </td>
            {/* <td className="contacts__cell second_cell">332</td> */}
            <td className="contacts__cell second_cell">14:00 – 18:00</td>
            <td className="contacts__cell second_cell"></td>
            <td className="contacts__cell second_cell">14:00 – 18:00</td>
            <td className="contacts__cell second_cell"></td>
            <td className="contacts__cell second_cell"></td>
          </tr>

          <tr className="contacts__line">
            <td className="contacts__cell second_cell">
              Полякова Наталия Владимировна<br></br>К.М.Н.
            </td>
            {/* <td className="contacts__cell second_cell">366</td> */}
            <td className="contacts__cell second_cell"></td>
            <td className="contacts__cell second_cell">14:00 – 16:00</td>
            <td className="contacts__cell second_cell"></td>
            <td className="contacts__cell second_cell">14:00 – 16:00</td>
            <td className="contacts__cell second_cell"></td>
          </tr>

          <tr className="contacts__line">
            <td className="contacts__cell second_cell">
              Кащеева Яна Викторовна<br></br>К.М.Н.
            </td>
            {/* <td className="contacts__cell second_cell">463</td> */}
            <td className="contacts__cell second_cell">10:00 – 12:00</td>
            <td className="contacts__cell second_cell"></td>
            <td className="contacts__cell second_cell"></td>
            <td className="contacts__cell second_cell"></td>
            <td className="contacts__cell second_cell">10:00 – 12:00</td>
          </tr>

          <th className="contacts__caption" colSpan={7}>
            Детский дерматологический приём
          </th>
          <tr className="contacts__line">
            <td className="contacts__cell second_cell">Врач</td>
            {/* <td className="contacts__cell second_cell">Кабинет</td> */}
            <td className="contacts__cell second_cell">Понедельник</td>
            <td className="contacts__cell second_cell">Вторник</td>
            <td className="contacts__cell second_cell">Среда</td>
            <td className="contacts__cell second_cell">Четверг</td>
            <td className="contacts__cell second_cell">Пятница</td>
          </tr>

          <tr className="contacts__line">
            <td className="contacts__cell second_cell">
              Фарина Юлия Анатольевна<br></br>Высшая категория
            </td>
            {/* <td className="contacts__cell second_cell">306</td> */}
            <td className="contacts__cell second_cell"></td>
            <td className="contacts__cell second_cell"></td>
            <td className="contacts__cell second_cell">11:00 – 16:00</td>
            <td className="contacts__cell second_cell"></td>
            <td className="contacts__cell second_cell"></td>
          </tr>

          <tr className="contacts__line">
            <td className="contacts__cell second_cell">
              Егорова Мария Олеговна<br></br>
            </td>
            {/* <td className="contacts__cell second_cell">301</td> */}
            <td className="contacts__cell second_cell">14:00 – 17:00</td>
            <td className="contacts__cell second_cell"></td>
            <td className="contacts__cell second_cell"></td>
            <td className="contacts__cell second_cell">14:00 – 17:00</td>
            <td className="contacts__cell second_cell"></td>
          </tr>

          <tr className="contacts__line">
            <td className="contacts__cell second_cell">
              Житниковская Анна Леонтьевна<br></br>Высшая категория
            </td>
            {/* <td className="contacts__cell second_cell">11</td> */}
            <td className="contacts__cell second_cell">11:00 – 14:00</td>
            <td className="contacts__cell second_cell"></td>
            <td className="contacts__cell second_cell"></td>
            <td className="contacts__cell second_cell">11:00 – 14:00</td>
            <td className="contacts__cell second_cell"></td>
          </tr>

          {/* <th className="contacts__caption" colSpan={7}>
            Прием Доктора медицинских наук, профессора
          </th>
          <tr className="contacts__line">
            <td className="contacts__cell second_cell">Врач</td>
            {/* <td className="contacts__cell second_cell">Кабинет</td>
            <td className="contacts__cell second_cell">Понедельник</td>
            <td className="contacts__cell second_cell">Вторник</td>
            <td className="contacts__cell second_cell">Среда</td>
            <td className="contacts__cell second_cell">Четверг</td>
            <td className="contacts__cell second_cell">Пятница</td>
          </tr>

          <tr className="contacts__line">
            <td className="contacts__cell second_cell">
              Филимонкова Нина Николаевна<br></br>Д.М.Н.
            </td>
            {/* <td className="contacts__cell second_cell">461</td>
            <td className="contacts__cell second_cell"></td>
            <td className="contacts__cell second_cell"></td>
            <td className="contacts__cell second_cell">10:00 – 12:00</td>
            <td className="contacts__cell second_cell"></td>
            <td className="contacts__cell second_cell"></td>
          </tr> */}

          <th className="contacts__caption" colSpan={7}>
            Прием уролога
          </th>
          <tr className="contacts__line">
            <td className="contacts__cell second_cell">Врач</td>
            {/* <td className="contacts__cell second_cell">Кабинет</td> */}
            <td className="contacts__cell second_cell">Понедельник</td>
            <td className="contacts__cell second_cell">Вторник</td>
            <td className="contacts__cell second_cell">Среда</td>
            <td className="contacts__cell second_cell">Четверг</td>
            <td className="contacts__cell second_cell">Пятница</td>
          </tr>

          <tr className="contacts__line">
            <td className="contacts__cell second_cell">
              Дмитриева Марина Викторовна<br></br>К.М.Н.
            </td>
            {/* <td className="contacts__cell second_cell">1 A</td> */}
            <td className="contacts__cell second_cell">09:00 – 13:00</td>
            <td className="contacts__cell second_cell">09:00 – 13:00</td>
            <td className="contacts__cell second_cell"></td>
            <td className="contacts__cell second_cell"></td>
            <td className="contacts__cell second_cell"></td>
          </tr>

          <th className="contacts__caption" colSpan={7}>
            Приём сифилидолога
          </th>
          <tr className="contacts__line">
            <td className="contacts__cell second_cell">Врач</td>
            {/* <td className="contacts__cell second_cell">Кабинет</td> */}
            <td className="contacts__cell second_cell">Понедельник</td>
            <td className="contacts__cell second_cell">Вторник</td>
            <td className="contacts__cell second_cell">Среда</td>
            <td className="contacts__cell second_cell">Четверг</td>
            <td className="contacts__cell second_cell">Пятница</td>
          </tr>

          <tr className="contacts__line">
            <td className="contacts__cell second_cell">
              Сурганова Вера Ивановна<br></br>К.М.Н.
            </td>
            {/* <td className="contacts__cell second_cell">351</td> */}
            <td className="contacts__cell second_cell">09:00 – 15:00</td>
            <td className="contacts__cell second_cell">09:00 – 15:00</td>
            <td className="contacts__cell second_cell">09:00 – 15:00</td>
            <td className="contacts__cell second_cell">09:00 – 15:00</td>
            <td className="contacts__cell second_cell">09:00 – 15:00</td>
          </tr>

          <th className="contacts__caption" colSpan={7}>
            Приём физиотерапевта
          </th>
          <tr className="contacts__line">
            <td className="contacts__cell second_cell">Врач</td>
            {/* <td className="contacts__cell second_cell">Кабинет</td> */}
            <td className="contacts__cell second_cell">Понедельник</td>
            <td className="contacts__cell second_cell">Вторник</td>
            <td className="contacts__cell second_cell">Среда</td>
            <td className="contacts__cell second_cell">Четверг</td>
            <td className="contacts__cell second_cell">Пятница</td>
          </tr>

          <tr className="contacts__line">
            <td className="contacts__cell second_cell">
              Горбунов Андрей Петрович<br></br>К.М.Н.
            </td>
            {/* <td className="contacts__cell second_cell">125</td> */}
            <td className="contacts__cell second_cell">09:00 – 13:00</td>
            <td className="contacts__cell second_cell"></td>
            <td className="contacts__cell second_cell">09:00 – 13:00</td>
            <td className="contacts__cell second_cell"></td>
            <td className="contacts__cell second_cell">09:00 – 13:00</td>
          </tr>
        </tbody>
      </table>
      <p className="dissertation__text">
        К.М.Н - Кандидат медицинских наук<br></br> Д.М.Н. - Доктор медицинских
        наук
      </p>
    </section>
  );
}
